<div class="wrapper">
   <div  class="btn apply" [ngClass]="{'hot': this.isOffsetsOutdated}" (click)="this.onApplyOffsetsClicked()">
      {{this.applyButtonText}}
   </div>
   <div class="btn watch" [ngClass]="{'watching': this.isWatching}" (click)="this.onWatchClicked()">
      Watch
   </div>
</div>